"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Slack = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_8_2)" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M5.14016 15.1181C5.14016 16.4976 4.0252 17.6126 2.64567 17.6126C1.26614 17.6126 0.151184 16.4976 0.151184 15.1181C0.151184 13.7386 1.26614 12.6236 2.64567 12.6236H5.14016V15.1181ZM6.3874 15.1181C6.3874 13.7386 7.50237 12.6236 8.88189 12.6236C10.2614 12.6236 11.3764 13.7386 11.3764 15.1181V21.3543C11.3764 22.7339 10.2614 23.8488 8.88189 23.8488C7.50237 23.8488 6.3874 22.7339 6.3874 21.3543V15.1181Z",
        fill: "#E01E5A"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M8.8819 5.10236C7.50237 5.10236 6.38741 3.9874 6.38741 2.60788C6.38741 1.22835 7.50237 0.113388 8.8819 0.113388C10.2614 0.113388 11.3764 1.22835 11.3764 2.60788V5.10236H8.8819ZM8.8819 6.36851C10.2614 6.36851 11.3764 7.48347 11.3764 8.86299C11.3764 10.2425 10.2614 11.3575 8.8819 11.3575H2.62678C1.24725 11.3575 0.132294 10.2425 0.132294 8.86299C0.132294 7.48347 1.24725 6.36851 2.62678 6.36851H8.8819Z",
        fill: "#36C5F0"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M18.8787 8.86299C18.8787 7.48347 19.9937 6.36851 21.3732 6.36851C22.7528 6.36851 23.8677 7.48347 23.8677 8.86299C23.8677 10.2425 22.7528 11.3575 21.3732 11.3575H18.8787V8.86299ZM17.6315 8.86299C17.6315 10.2425 16.5165 11.3575 15.137 11.3575C13.7575 11.3575 12.6425 10.2425 12.6425 8.86299V2.60788C12.6425 1.22835 13.7575 0.113388 15.137 0.113388C16.5165 0.113388 17.6315 1.22835 17.6315 2.60788V8.86299Z",
        fill: "#2EB67D"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M15.137 18.8598C16.5165 18.8598 17.6315 19.9748 17.6315 21.3543C17.6315 22.7339 16.5165 23.8488 15.137 23.8488C13.7575 23.8488 12.6425 22.7339 12.6425 21.3543V18.8598H15.137ZM15.137 17.6126C13.7575 17.6126 12.6425 16.4976 12.6425 15.1181C12.6425 13.7386 13.7575 12.6236 15.137 12.6236H21.3921C22.7717 12.6236 23.8866 13.7386 23.8866 15.1181C23.8866 16.4976 22.7717 17.6126 21.3921 17.6126H15.137Z",
        fill: "#ECB22E"
      }
    )),
    /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_8_2" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" })))
  );
};
export default Slack;
